import React from "react";
import { Container, Card, Button } from "react-bootstrap";
import { useNavigate } from 'react-router-dom';
const HeroBannerSection = () => {
  const navigate = useNavigate();
  return (
    <div className="hero-banner-section">
      <Container className="d-flex justify-content-center">
        <Card>
          <h2>Get a clearer picture of <br/><span>your finances</span></h2>
          <p>
            Find out if you pre-qualify for a home loan in as little as 5
            minutes.* Pre-qualification will not impact your credit score.
          </p>
          <Button className="custom-bttn style-3 w-100 w-md-50" 
          onClick={() => navigate('/get-pre‑qualified', { state: { hideHero: true } })}>
            Get Pre-qualified
          </Button>
          <p className="mb-0">
            Your information is safe and secure with us.
          </p>
        </Card>
      </Container>
    </div>
  );
};

export default HeroBannerSection;
